import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KeyValueModel } from '../models/key-value.model';

@Injectable({
  providedIn: 'root'
})

export class CommonService {

  constructor() { }


  //#region array

  static sortArrayByArray(array, sortArray, sortKey?, sortFromTheBegin = true): any[] {

    ////////////////////////////////////////////// with key
    if (sortKey) {
      const sortMarkets = (array, sortArray) => {
        return [...array].sort((a, b) =>
          sortFromTheBegin ?
            sortArray.indexOf(b[sortKey]) - sortArray.indexOf(a[sortKey]) :
            sortArray.indexOf(a[sortKey]) - sortArray.indexOf(b[sortKey])
        )
      }
      return sortMarkets(array, sortArray)
    }
    ////////////////////////////////////////////// without key
    else {
      const sortMarkets = (array, sortArray) => {
        return [...array].sort((a, b) =>
          sortFromTheBegin ?
            sortArray.indexOf(b) - sortArray.indexOf(a) :
            sortArray.indexOf(a) - sortArray.indexOf(b)
        )
      }
      return sortMarkets(array, sortArray)
    }

  }

  //#endregion


}



